import React from 'react'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'
import { Button } from '@wartek-id/button-v1'
import { Spinner } from '@wartek-id/spinner'

export type DocCollectionSectionProps = {
  title: string
  subtitle: string
  filePlaceholder: string
  fileData?: {
    url: string
    name: string
  }
  isLoading?: boolean
  onClick: () => void
  onDocDeleteClick: () => void
}

export const DocCollectionSection = (props: DocCollectionSectionProps) => {
  const fileDefaultData = {
    url: '',
    name: '',
    fileData: '',
  }
  const {
    title,
    subtitle,
    filePlaceholder,
    fileData = fileDefaultData,
    isLoading = false,
    onDocDeleteClick,
    onClick,
  } = props
  const [file, setFile] = React.useState(fileData)

  React.useEffect(() => {
    setFile(fileData)
  }, [fileData])

  return (
    <div className="mb-6">
      <Text variant="body">{title}</Text>
      <Text variant="helper" color="subdued" className="mt-1">
        {subtitle}
      </Text>
      {file.url ? (
        <div className="rounded w-full my-2 p-3 border border-black">
          <div className="flex flex-row items-center justify-between">
            <div className="flex flex-row items-center" onClick={onClick}>
              <Icon>text_snippet</Icon>
              <Text className="ml-2" variant="body">
                {file.name}
              </Text>
            </div>
            {isLoading ? (
              <Spinner size="sm" />
            ) : (
              <Button
                variant="ghost"
                size="sm"
                color="red"
                onClick={() => {
                  setFile(fileDefaultData)
                  onDocDeleteClick && onDocDeleteClick()
                }}
              >
                Hapus
              </Button>
            )}
          </div>
        </div>
      ) : (
        <div
          className="rounded w-full my-2 border-dashed p-3 border-2 border-subdued"
          onClick={onClick}
        >
          <div className="flex flex-row items-center">
            <Icon className="-rotate-45">attachment</Icon>
            <Text
              color="subdued"
              className="ml-2"
              style={{ fontStyle: 'italic' }}
            >
              {filePlaceholder}
            </Text>
          </div>
        </div>
      )}
    </div>
  )
}
